import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerDataTableComponent } from './borrower-data-table.component';
import { MatTableModule } from '@angular/material/table';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { SSNModule } from 'app/pipes/ssn/ssn-pipe.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    BorrowerDataTableComponent
  ],
  imports: [
    CommonModule,
    PhoneModule,
    SSNModule,
    MatTableModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    BorrowerDataTableComponent
  ]
})
export class BorrowerDataTableModule { }
